module.exports = __webpack_public_path__ + "img/pingtai4.47d701ef.png";